<template>
  <div class="chart-wrapper">
    <VueApexCharts height="300" :chart="apexCharts" :options="{ ...options, chart: { ...options.chart, ...chart }, xaxis: { ...options.xaxis, categories: categories } }" :series="series" l></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Apex from 'apexcharts'
import moment from 'moment'
import i18n from '@/i18n'
const apexCharts = require('@/locales/apexCharts.locales.json')
Apex.chart = apexCharts
export default {
  name: 'UiChart',

  props: {
    options: {
      type: Object,
      default: () => {}
    },
    series: { type: Array, default: () => [] },
    apexCharts: {
      type: Object,
      default: () => apexCharts
    },
    noConvertDate: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    options: function (newOptions) {
      if (!!newOptions && !!newOptions.xaxis && newOptions.xaxis.categories.length) {
        this.categories = newOptions.xaxis.categories.map(v => {
          if (!moment(new Date(v)).isValid() || ([...v]).reduce((prev, char) => prev || (/[a-zA-Z]/).test(char), false) || this.noConvertDate) {
            if (v.toLowerCase().includes('week') && !this.noConvertDate) {
              return v.toLowerCase().replace('week', i18n.t('week'))
            }
            return v
          }
          if (v.length === 4) {
            return v
          }
          return i18n.t('date_format_with_params_no_weekday',
            { date: new Date(v).getDate(), month: i18n.t(moment(new Date(v)).format('MMM').toLowerCase()), year: new Date(v).getFullYear() })
        })
      }
    }
  },
  data: function () {
    return {
      chart: apexCharts.chart,
      categories: !!this.options && !!this.options.xaxis && this.options.xaxis.categories.length ? this.options.xaxis.categories.map(v => {
        if (!moment(new Date(v)).isValid() || ([...v]).reduce((prev, char) => prev || (/[a-zA-Z]/).test(char), false)) {
          if (v.toLowerCase().includes('week')) {
            return v.toLowerCase().replace('week', i18n.t('week'))
          }
          return v
        }
        if (v.length === 4) {
          return v
        }
        return i18n.t('date_format_with_params_no_weekday',
          { date: new Date(v).getDate(), month: i18n.t(moment(new Date(v)).format('MMM').toLowerCase()), year: new Date(v).getFullYear() })
      }) : []
    }
  },

  components: {
    VueApexCharts
  }
}
</script>

<style lang="scss" scoped>
  .chart-wrapper {
    margin-bottom: 15px;
    opacity: 1;
  }
  .loading-chart {
    opacity: 0.5 !important;
  }
</style>
